import { Breadcrumb, Col, Row } from 'antd';
import React from 'react';
import { MetaHeader } from '@shares/MetaHeader';
import { MainTitle } from './modern/MainTitle';
import StandardLayoutContainer from './standard/StandardLayoutContainer';
import ModernLayoutContainer from './modern/ModernLayoutContainer';
import CheckSwitchLayout from './CheckSwitchLayout';
import { LinkO2O } from '../../common/LinkO2O';

interface ILayoutRendererProps {
  props: any;

  selectedLeftNavStandard?: string;
  selectedSubMenuStandard?: string;
  selectedLeftNavModern?: string;
  selectedSubMenuModern?: string;

  pageTitle: string;
  pageTitleIcon?: React.ReactNode;

  breadcrumbItemsStandard?: Array<{
    title: string;
    path?: string;
  }>;
  breadcrumbItemsModern?: Array<{
    title: string;
    path?: string;
  }>;
  renderRight?: () => React.ReactNode;

  renderContentLayout: (version?: string) => React.ReactNode;

  metaTitle?: string;
}

const DashboardPageLayoutV2: React.FC<ILayoutRendererProps> = ({
  props,
  selectedLeftNavStandard,
  selectedSubMenuStandard,
  selectedLeftNavModern,
  selectedSubMenuModern,
  pageTitle,
  pageTitleIcon,
  breadcrumbItemsStandard,
  breadcrumbItemsModern,
  renderContentLayout,
  renderRight,
  metaTitle,
}) => {
  const renderBreadcrumb = (breadcrumbItems: typeof breadcrumbItemsStandard | typeof breadcrumbItemsModern) => {
    return (
      <Breadcrumb>
        {breadcrumbItems?.map((item, index) => (
          <Breadcrumb.Item key={index}>
            {item.path ? (
              <LinkO2O {...props} to={{ pathname: item.path }}>
                {item.title}
              </LinkO2O>
            ) : (
              item.title
            )}
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
    );
  };

  const renderOldTheme = (version: string) => {
    return (
      <StandardLayoutContainer
        {...props}
        selectedLeftNav={selectedLeftNavStandard}
        selectedSubMenu={selectedSubMenuStandard}
      >
        {renderContentWrapper(version)}
      </StandardLayoutContainer>
    );
  };

  const renderNewTheme = (version: string) => {
    return (
      <ModernLayoutContainer
        {...props}
        selectedLeftNav={selectedLeftNavModern || selectedLeftNavStandard}
        selectedSubMenu={selectedSubMenuModern || selectedSubMenuStandard}
        renderBreadCrumbTop={() => renderBreadcrumb(breadcrumbItemsModern)}
        renderTitle={() => (
          <MainTitle
            renderTitle={
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 10,
                }}
              >
                {pageTitleIcon}
                {pageTitle}
              </div>
            }
            renderRight={renderRight && renderRight()}
          />
        )}
      >
        {renderContentWrapper(version)}
      </ModernLayoutContainer>
    );
  };

  const renderContentWrapper = (version?: string) => {
    return (
      <div className='org-page'>
        <MetaHeader title={metaTitle || pageTitle} />

        <div className='contentLayout'>
          {(version === 'v1' || !version) && (
            <>
              <Row
                type='flex'
                justify='space-between'
                align='middle'
                style={{
                  ...(renderRight && {
                    marginBottom: -15,
                  }),
                }}
              >
                <Col>{renderBreadcrumb(breadcrumbItemsStandard)}</Col>
                {renderRight && <Col>{renderRight()}</Col>}
              </Row>
              <br />
            </>
          )}

          <div
            className='containerInner'
            style={{
              padding: version === 'v1' || !version ? 24 : '',
              overflowX: 'auto',
            }}
          >
            {renderContentLayout(version)}
          </div>
        </div>
      </div>
    );
  };

  return (
    <CheckSwitchLayout
      v1={(version: string) => renderOldTheme(version)}
      v2={(version: string) => renderNewTheme(version)}
    />
  );
};

export default DashboardPageLayoutV2;
